// Small NomOS reference lookups shared by the core family (countries, climate zones), cached per session.
import { registerTenantCache, getConfig, queryRecords, scalar } from '../client';

const cache = new Map<string, Promise<Map<string, string>>>();
export function clearLookupCache(): void { cache.clear(); }
registerTenantCache(clearLookupCache);

/** record_id -> `field` value for every record of `type` (reference tables only: countries, climate zones). */
function byField(type: string, field: string): Promise<Map<string, string>> {
  const cfg = getConfig();
  const key = `${cfg.baseUrl}|${cfg.tenant}|${type}|${field}`;
  let p = cache.get(key);
  if (!p) {
    p = queryRecords(type, { fields: [field], limit: 1000 }).then((r) => {
      const m = new Map<string, string>();
      for (const row of r.rows) { const v = scalar(row.values[field]); if (typeof v === 'string') m.set(row.record_id, v); }
      return m;
    });
    p.catch(() => cache.delete(key));
    cache.set(key, p);
  }
  return p;
}

export const countryCodes = () => byField('country', 'code');           // record_id -> ISO2
export const climateZoneCodes = () => byField('climate_zone', 'code');  // record_id -> Koppen code

export async function countryRecordId(code: string): Promise<string | undefined> {
  const upper = code.toUpperCase();
  for (const [id, c] of await countryCodes()) if (c.toUpperCase() === upper) return id;
  return undefined;
}

export const isoDate = (d: Date) => d.toISOString().slice(0, 10);
